//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming



export class BaseEntity {
    identifier : string;
    createdOn : string ;
    modifiedOn : string ;
    disabledOn : string ;
    disabled : boolean;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.modifiedOn = null;
                this.disabledOn = null;
                this.disabled = false ;
        }
}

export class BackendNotification extends BaseEntity {
    userIdentifier : string;
    readOn : string ;
    comment : Comment;

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.readOn = null;
                this.comment = new Comment();
        }
}

export class Comment {
    identifier : string;
    createdOn : string ;
    startDate : string ;
    endDate : string ;
    author : NameIdentifier;
    subject : NameIdentifier;
    text : string;
    attachments : Attachment[];
    attachmentUrl : string[];
    status : string;
    type : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.startDate = null;
                this.endDate = null;
                this.author = new NameIdentifier();
                this.subject = new NameIdentifier();
                this.text = "" ;
                this.attachments = [];
                this.attachmentUrl = [];
                this.status = "" ;
                this.type = "" ;
        }
}

export class NameIdentifier {
    identifier : string;
    name : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.name = "" ;
        }
}

export class Attachment {
    fileIdentifier : string;
    fileName : string;
    mimeType : string;
    lastModifiedOn : string ;
    publicUrl : string;
    region : string;
    bucket : string;
    subDir : string;

    constructor() 
    {
    	            this.fileIdentifier = "" ;
                this.fileName = "" ;
                this.mimeType = "" ;
                this.lastModifiedOn = null;
                this.publicUrl = "" ;
                this.region = "" ;
                this.bucket = "" ;
                this.subDir = "" ;
        }
}

export class ContrattoCollaborazione extends BaseEntity {
    user : NameIdentifier;
    documentUrl : string[];
    signedOn : string ;
    signedDocumentAttachment : Attachment[];
    signedDocumentUrl : string[];
    otp : string;
    attachments : Comment[];
    approvedOn : string ;
    rejectedOn : string ;
    rejectionReason : string;
    comments : Comment[];

    constructor() 
    {
    	        super();
		            this.user = new NameIdentifier();
                this.documentUrl = [];
                this.signedOn = null;
                this.signedDocumentAttachment = [];
                this.signedDocumentUrl = [];
                this.otp = "" ;
                this.attachments = [];
                this.approvedOn = null;
                this.rejectedOn = null;
                this.rejectionReason = "" ;
                this.comments = [];
        }
}

export class TextIdentifier {
    order : number;
    text : string;
    identifier : string;

    constructor() 
    {
    	            this.order = null ;
                this.text = "" ;
                this.identifier = "" ;
        }
}

export class DocumentoDashboard extends BaseEntity {
    name : string;
    description : string;
    url : string;
    attachment : Attachment;
    folder : string;
    userRead : DateValueOfNameIdentifier[];
    visibleBy : string[];

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.description = "" ;
                this.url = "" ;
                this.attachment = new Attachment();
                this.folder = "" ;
                this.userRead = [];
                this.visibleBy = [];
        }
}

export class DateValueOfNameIdentifier {
    date : string ;
    value : NameIdentifier;

    constructor() 
    {
    	            this.date = null;
                this.value = new NameIdentifier();
        }
}

export class GetFoldersResponseVm {
    name : string;
    hasNew : boolean;

    constructor() 
    {
    	            this.name = "" ;
                this.hasNew = false ;
        }
}

export class EsclusioneOrariPrenotazione extends BaseEntity {
    userIdentifier : string;
    date : string ;
    orario : FasciaOraria;

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.date = null;
                this.orario = new FasciaOraria();
        }
}

export class FasciaOraria {
    from : string;
    to : string;

    constructor() 
    {
    	            this.from = "" ;
                this.to = "" ;
        }
}

export class FaqNode extends BaseEntity {
    nodeText : string;
    answersList : TextIdentifier[];

    constructor() 
    {
    	        super();
		            this.nodeText = "" ;
                this.answersList = [];
        }
}

export class InclusioneOrariPrenotazione extends BaseEntity {
    userIdentifier : string;
    date : string ;
    orario : FasciaOraria[];

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.date = null;
                this.orario = [];
        }
}

export class KeyValuePairOfStringAndString {
    key : string;
    value : string;

    constructor() 
    {
    	            this.key = "" ;
                this.value = "" ;
        }
}

export class LocalizedValue {
    values : { [key: string]: string; };

    constructor() 
    {
    	            this.values = null;
        }
}

export class LocalizedEntity extends LocalizedValue {
    key : string;
    identifier : string;

    constructor() 
    {
    	        super();
		            this.key = "" ;
                this.identifier = "" ;
        }
}

export class LoginData {
    userIdentifier : string;
    token : string;

    constructor() 
    {
    	            this.userIdentifier = "" ;
                this.token = "" ;
        }
}

export class LoginVm {
    username : string;
    password : string;

    constructor() 
    {
    	            this.username = "" ;
                this.password = "" ;
        }
}

export class RegisterVm {
    name : string;
    surname : string;
    email : string;
    password : string;
    referralCode : string;
    nazione : string;
    nomeCentro : string;
    telephone : Telephone;

    constructor() 
    {
    	            this.name = "" ;
                this.surname = "" ;
                this.email = "" ;
                this.password = "" ;
                this.referralCode = "" ;
                this.nazione = "" ;
                this.nomeCentro = "" ;
                this.telephone = new Telephone();
        }
}

export class Telephone {
    prefix : string;
    number : string;
    completeNumber : string;

    constructor() 
    {
    	            this.prefix = "" ;
                this.number = "" ;
                this.completeNumber = "" ;
        }
}

export class BaseUser extends BaseEntity {
    personalData : PersonalData;
    contactData : ContactData;
    fiscalData : FiscalData;
    referralCode : string;
    gestioneAcceptedOn : string ;
    reteGestioneParent : NameIdentifier;
    reteCommercialeParent : NameIdentifier;
    preferredCulture : string;
    role : string;
    linkedAccounts : NameIdentifier[];
    reteGestioneStoricoAssegnazioni : DateValueOfStoricoAssegnazione[];
    reteCommercialeStoricoAssegnazioni : DateValueOfStoricoAssegnazione[];

    constructor() 
    {
    	        super();
		            this.personalData = new PersonalData();
                this.contactData = new ContactData();
                this.fiscalData = new FiscalData();
                this.referralCode = "" ;
                this.gestioneAcceptedOn = null;
                this.reteGestioneParent = new NameIdentifier();
                this.reteCommercialeParent = new NameIdentifier();
                this.preferredCulture = "" ;
                this.role = "" ;
                this.linkedAccounts = [];
                this.reteGestioneStoricoAssegnazioni = [];
                this.reteCommercialeStoricoAssegnazioni = [];
        }
}

export class Lead extends BaseUser {
    authData : AuthData;
    calcoliFumo : CalcoliFumo;
    socialNetworksData : SocialNetworksData;
    note : Comment[];
    comments : Comment[];
    statoCommerciale : string;
    status : string;
    subStatus : string;
    cronologiaStati : Comment[];
    scadenze : Comment[];
    list : string;
    source : string;
    lavorato : boolean;
    provvigioniCassaforte : boolean;
    stripeCustomerIds : AutoDictionaryOfStringAndString;
    productLevel : number;
    pianoProvvigioni : PianoProvvigioni;
    storicoPianoProvvigioni : DateValueOfPianoProvvigioni[];

    constructor() 
    {
    	        super();
		            this.authData = new AuthData();
                this.calcoliFumo = new CalcoliFumo();
                this.socialNetworksData = new SocialNetworksData();
                this.note = [];
                this.comments = [];
                this.statoCommerciale = "" ;
                this.status = "" ;
                this.subStatus = "" ;
                this.cronologiaStati = [];
                this.scadenze = [];
                this.list = "" ;
                this.source = "" ;
                this.lavorato = false ;
                this.provvigioniCassaforte = false ;
                this.stripeCustomerIds = new AutoDictionaryOfStringAndString();
                this.productLevel = null ;
                this.pianoProvvigioni = new PianoProvvigioni();
                this.storicoPianoProvvigioni = [];
        }
}

export class Cliente extends Lead {

    constructor() 
    {
    	        super();
		    }
}

export class AuthData {
    username : string;
    password : string;
    tempPassword : string;
    tokenForResetPassword : string;
    passwordExpirationDate : string ;
    loginEnabled : boolean;

    constructor() 
    {
    	            this.username = "" ;
                this.password = "" ;
                this.tempPassword = "" ;
                this.tokenForResetPassword = "" ;
                this.passwordExpirationDate = null;
                this.loginEnabled = false ;
        }
}

export class CalcoliFumo {
    nonFumatore : boolean;
    hoSmesso : boolean;
    annoInizio : number;
    meseInizio : number;
    quanteSigaretteAlGiorno : number;
    prezzoPacchettoSigarette : number;
    inizioTrattamento : string ;

    constructor() 
    {
    	            this.nonFumatore = false ;
                this.hoSmesso = false ;
                this.annoInizio = null ;
                this.meseInizio = null ;
                this.quanteSigaretteAlGiorno = null ;
                this.prezzoPacchettoSigarette = null ;
                this.inizioTrattamento = null;
        }
}

export class SocialNetworksData {
    facebook : string;
    instagram : string;
    twitter : string;

    constructor() 
    {
    	            this.facebook = "" ;
                this.instagram = "" ;
                this.twitter = "" ;
        }
}

export class AutoDictionaryOfStringAndString {
    item : string;

    [key: string]: string | any; 

    constructor() 
    {
    	            this.item = "" ;
        }
}

export class PianoProvvigioni {
    qualifica : QualificaProvvigioni;
    puntiReteMaturati : number;
    puntiReteMaturatiMensili : number;
    puntiReteMaturatiTrimestrali : number;
    puntiReteMaturatiSemestrali : number;
    puntiReteMaturatiAnnuali : number;
    isLocked : boolean;
    disattivaCalcolo : boolean;

    constructor() 
    {
    	            this.qualifica = new QualificaProvvigioni();
                this.puntiReteMaturati = null ;
                this.puntiReteMaturatiMensili = null ;
                this.puntiReteMaturatiTrimestrali = null ;
                this.puntiReteMaturatiSemestrali = null ;
                this.puntiReteMaturatiAnnuali = null ;
                this.isLocked = false ;
                this.disattivaCalcolo = false ;
        }
}

export class QualificaProvvigioni {
    codiceQualifica : string;
    puntiTotaliNecessari : number;
    euroPerPunto : number;
    modalitaCalcolo : string;

    constructor() 
    {
    	            this.codiceQualifica = "" ;
                this.puntiTotaliNecessari = null ;
                this.euroPerPunto = null ;
                this.modalitaCalcolo = "" ;
        }
}

export class DateValueOfPianoProvvigioni {
    date : string ;
    value : PianoProvvigioni;

    constructor() 
    {
    	            this.date = null;
                this.value = new PianoProvvigioni();
        }
}

export class PersonalData {
    name : string;
    surname : string;
    nazione : string;
    sesso : string;
    profilePicture : string;
    completeName : string;

    constructor() 
    {
    	            this.name = "" ;
                this.surname = "" ;
                this.nazione = "" ;
                this.sesso = "" ;
                this.profilePicture = "" ;
                this.completeName = "" ;
        }
}

export class ContactData {
    contactName : string;
    email : string;
    telephone : Telephone;
    shippingAddress : Address;

    constructor() 
    {
    	            this.contactName = "" ;
                this.email = "" ;
                this.telephone = new Telephone();
                this.shippingAddress = new Address();
        }
}

export class Address {
    typedAddress : string;
    citta : string;
    provincia : string;
    cap : string;
    scalaPianoInterno : string;
    via : string;
    civico : string;
    note : string;
    nazione : string;
    regione : string;
    latLong : LatLong;
    completeAddress : string;

    constructor() 
    {
    	            this.typedAddress = "" ;
                this.citta = "" ;
                this.provincia = "" ;
                this.cap = "" ;
                this.scalaPianoInterno = "" ;
                this.via = "" ;
                this.civico = "" ;
                this.note = "" ;
                this.nazione = "" ;
                this.regione = "" ;
                this.latLong = new LatLong();
                this.completeAddress = "" ;
        }
}

export class LatLong {
    lat : number;
    long : number;

    constructor() 
    {
    	            this.lat = null ;
                this.long = null ;
        }
}

export class FiscalData {
    codiceFiscale : string;
    hasVat : boolean;
    vatNumber : string;
    codiceDestinatario : string;
    pec : string;
    fiscalAddress : Address;
    dataNascita : string ;
    luogoNascita : string;

    constructor() 
    {
    	            this.codiceFiscale = "" ;
                this.hasVat = false ;
                this.vatNumber = "" ;
                this.codiceDestinatario = "" ;
                this.pec = "" ;
                this.fiscalAddress = new Address();
                this.dataNascita = null;
                this.luogoNascita = "" ;
        }
}

export class DateValueOfStoricoAssegnazione {
    date : string ;
    value : StoricoAssegnazione;

    constructor() 
    {
    	            this.date = null;
                this.value = new StoricoAssegnazione();
        }
}

export class StoricoAssegnazione {
    assigner : NameIdentifier;
    assigned : NameIdentifier;

    constructor() 
    {
    	            this.assigner = new NameIdentifier();
                this.assigned = new NameIdentifier();
        }
}

export class PagedResultOfMailSentLog {
    data : MailSentLog[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class MailSentLog extends BaseEntity {
    mailTemplateName : string;
    mailTemplateNumber : string;
    jsonVariables : string;
    recipients : string[];

    constructor() 
    {
    	        super();
		            this.mailTemplateName = "" ;
                this.mailTemplateNumber = "" ;
                this.jsonVariables = "" ;
                this.recipients = [];
        }
}

export class BaseListFilterVm {
    pageNumber : number;
    perPage : number;
    sortBy : SortByParameter;

    constructor() 
    {
    	            this.pageNumber = null ;
                this.perPage = null ;
                this.sortBy = new SortByParameter();
        }
}

export class MailSentLogListFilterVm extends BaseListFilterVm {
    createdOn : string ;
    mailTemplateName : string;
    mailTemplateNumber : string;
    recipients : string;
    jsonVariables : string;

    constructor() 
    {
    	        super();
		            this.createdOn = null;
                this.mailTemplateName = "" ;
                this.mailTemplateNumber = "" ;
                this.recipients = "" ;
                this.jsonVariables = "" ;
        }
}

export class SortByParameter {
    propertyName : string;
    ascending : boolean;

    constructor() 
    {
    	            this.propertyName = "" ;
                this.ascending = false ;
        }
}

export class MessageOfTheDay extends BaseEntity {
    message : string;
    author : string;
    dayNumber : number;
    monthNumber : number;

    constructor() 
    {
    	        super();
		            this.message = "" ;
                this.author = "" ;
                this.dayNumber = null ;
                this.monthNumber = null ;
        }
}

export class Nazione extends BaseEntity {
    name : string;
    alpha2Code : string;
    alpha3Code : string;
    callingCode : string;
    currency : string;
    userRicezioneLead : NameIdentifier;
    puntiAccettazione : number;

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.alpha2Code = "" ;
                this.alpha3Code = "" ;
                this.callingCode = "" ;
                this.currency = "" ;
                this.userRicezioneLead = new NameIdentifier();
                this.puntiAccettazione = null ;
        }
}

export class NumberNazione {
    prefix : string;
    nazione : string;

    constructor() 
    {
    	            this.prefix = "" ;
                this.nazione = "" ;
        }
}

export class PagamentoBonifico extends BaseEntity {
    acquistoClienteIdentifier : string;
    offers : OfferInCartVm[];
    acquistoIdentifier : string;
    prodotto : NameIdentifier;
    cliente : NameIdentifier;
    importo : string;
    valuta : string;
    confirmedOn : string ;
    comments : Comment[];
    documentUrl : string;
    documentUrl2 : string;
    reteGestioneParent : NameIdentifier;
    reteCommercialeParent : NameIdentifier;
    activateOnCliente : NameIdentifier;
    note : string;

    constructor() 
    {
    	        super();
		            this.acquistoClienteIdentifier = "" ;
                this.offers = [];
                this.acquistoIdentifier = "" ;
                this.prodotto = new NameIdentifier();
                this.cliente = new NameIdentifier();
                this.importo = "" ;
                this.valuta = "" ;
                this.confirmedOn = null;
                this.comments = [];
                this.documentUrl = "" ;
                this.documentUrl2 = "" ;
                this.reteGestioneParent = new NameIdentifier();
                this.reteCommercialeParent = new NameIdentifier();
                this.activateOnCliente = new NameIdentifier();
                this.note = "" ;
        }
}

export class OfferInCartVm {
    identifier : string;
    imageUrl : string;
    name : string;
    quantity : number;
    points : number;
    priceEntry : PreziarioEntry;

    constructor() 
    {
    	            this.identifier = "" ;
                this.imageUrl = "" ;
                this.name = "" ;
                this.quantity = null ;
                this.points = null ;
                this.priceEntry = new PreziarioEntry();
        }
}

export class PreziarioEntry {
    simbolo : string;
    currency : string;
    importo : number;
    vatPerc : number;
    punti : number;

    constructor() 
    {
    	            this.simbolo = "" ;
                this.currency = "" ;
                this.importo = null ;
                this.vatPerc = null ;
                this.punti = null ;
        }
}

export class PagedResultOfPagamentoBonifico {
    data : PagamentoBonifico[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class PagamentoBonificoListFilterVm extends BaseListFilterVm {
    fromDate : string ;
    toDate : string ;
    cliente : string;
    prodotto : string;
    offers : string;
    importo : string;
    valuta : string;
    approvedFromDate : string ;
    approvedToDate : string ;
    documentoCaricato : boolean;
    disabled : boolean;

    constructor() 
    {
    	        super();
		            this.fromDate = null;
                this.toDate = null;
                this.cliente = "" ;
                this.prodotto = "" ;
                this.offers = "" ;
                this.importo = "" ;
                this.valuta = "" ;
                this.approvedFromDate = null;
                this.approvedToDate = null;
                this.documentoCaricato = false ;
                this.disabled = false ;
        }
}

export class AcquistoCliente extends BaseEntity {
    clienteIdentifier : string;
    offers : OfferInCartVm[];
    totalPrice : number;
    trackingNumber : string;
    number : string;
    shippingAddress : Address;
    points : number;
    status : string;
    statusHistory : DateValueOfString[];
    speseSpedizione : number;
    hiddenToCustomer : boolean;
    lavorato : boolean;
    hasPromoCode : boolean;
    note : string;
    attachments : Attachment[];
    allegati : AttachmentNameUrl[];

    constructor() 
    {
    	        super();
		            this.clienteIdentifier = "" ;
                this.offers = [];
                this.totalPrice = null ;
                this.trackingNumber = "" ;
                this.number = "" ;
                this.shippingAddress = new Address();
                this.points = null ;
                this.status = "" ;
                this.statusHistory = [];
                this.speseSpedizione = null ;
                this.hiddenToCustomer = false ;
                this.lavorato = false ;
                this.hasPromoCode = false ;
                this.note = "" ;
                this.attachments = [];
                this.allegati = [];
        }
}

export class AcquistoClienteListVm extends AcquistoCliente {
    nome : string;
    cognome : string;

    constructor() 
    {
    	        super();
		            this.nome = "" ;
                this.cognome = "" ;
        }
}

export class DateValueOfString {
    date : string ;
    value : string;

    constructor() 
    {
    	            this.date = null;
                this.value = "" ;
        }
}

export class AttachmentNameUrl {
    name : string;
    url : string;

    constructor() 
    {
    	            this.name = "" ;
                this.url = "" ;
        }
}

export class PagedResultOfAcquistoClienteListVm {
    data : AcquistoClienteListVm[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class AcquistoClienteListFilterVm extends BaseListFilterVm {
    createdOn : string ;
    name : string;
    surname : string;
    nascosto : boolean;
    totaleCarrello : number;
    speseSpedizione : number;
    numeroOrdine : string;
    punti : number;
    carrello : string;
    stato : string;
    lavorato : boolean;

    constructor() 
    {
    	        super();
		            this.createdOn = null;
                this.name = "" ;
                this.surname = "" ;
                this.nascosto = false ;
                this.totaleCarrello = null ;
                this.speseSpedizione = null ;
                this.numeroOrdine = "" ;
                this.punti = null ;
                this.carrello = "" ;
                this.stato = "" ;
                this.lavorato = false ;
        }
}

export class AcquistoClienteVm {
    createdOn : string ;
    identifier : string;
    acquistoNumber : string;
    totalPrice : number;
    status : string;
    hiddenToCustomer : boolean;

    constructor() 
    {
    	            this.createdOn = null;
                this.identifier = "" ;
                this.acquistoNumber = "" ;
                this.totalPrice = null ;
                this.status = "" ;
                this.hiddenToCustomer = false ;
        }
}

export class AcquistoClienteVmWithOffers extends AcquistoClienteVm {
    offers : OfferInCartVm[];

    constructor() 
    {
    	        super();
		            this.offers = [];
        }
}

export class BaseProductVm {
    identifier : string;
    createdOn : string ;
    nome : string;
    subTitle : string;
    productType : string;
    displayOrder : number;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.nome = "" ;
                this.subTitle = "" ;
                this.productType = "" ;
                this.displayOrder = null ;
        }
}

export class BaseProduct extends BaseEntity {
    nome : string;
    subTitle : string;
    productType : string;
    displayOrder : number;

    constructor() 
    {
    	        super();
		            this.nome = "" ;
                this.subTitle = "" ;
                this.productType = "" ;
                this.displayOrder = null ;
        }
}

export class Offerta extends BaseEntity {
    name : string;
    subTitle : string;
    shopCategoryIdentifier : string;
    products : string[];
    preziario : { [key: string]: PreziarioEntry; };
    imgUrl : string;
    displayOrder : number;
    minProductLevelRequired : number;
    maxProductLevelRequired : number;
    nazioneFilter : string[];
    rolesFilter : string[];
    applyProductLevel : boolean;
    productLevelApplied : number;
    upsellOffers : string[];
    appleIapId : string;
    requirements : string[];

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.subTitle = "" ;
                this.shopCategoryIdentifier = "" ;
                this.products = [];
                this.preziario = {};
                this.imgUrl = "" ;
                this.displayOrder = null ;
                this.minProductLevelRequired = null ;
                this.maxProductLevelRequired = null ;
                this.nazioneFilter = [];
                this.rolesFilter = [];
                this.applyProductLevel = false ;
                this.productLevelApplied = null ;
                this.upsellOffers = [];
                this.appleIapId = "" ;
                this.requirements = [];
        }
}

export class OffertaForListVm extends Offerta {
    shopCategoryName : string;

    constructor() 
    {
    	        super();
		            this.shopCategoryName = "" ;
        }
}

export class BuyCartRequestVm {
    stripeToken : string;
    stripePublicKey : string;
    payPalClientId : string;
    payPalOrderId : string;
    identifier : string;
    dataInizio : string ;
    appleIapId : string;
    upsellOfferIdentifier : string;
    activateOnCliente : NameIdentifier;

    constructor() 
    {
    	            this.stripeToken = "" ;
                this.stripePublicKey = "" ;
                this.payPalClientId = "" ;
                this.payPalOrderId = "" ;
                this.identifier = "" ;
                this.dataInizio = null;
                this.appleIapId = "" ;
                this.upsellOfferIdentifier = "" ;
                this.activateOnCliente = new NameIdentifier();
        }
}

export class OfferWithBoughtVm extends Offerta {
    bought : boolean;

    constructor() 
    {
    	        super();
		            this.bought = false ;
        }
}

export class ProductAppuntamento extends BaseProduct {
    puntiAssegnatiAlGestore : number;
    numeroTicketCreati : number;
    ruoloPrenotazione : string;

    constructor() 
    {
    	        super();
		            this.puntiAssegnatiAlGestore = null ;
                this.numeroTicketCreati = null ;
                this.ruoloPrenotazione = "" ;
        }
}

export class ProductCourse extends BaseProduct {
    courseContents : CourseContent[];

    constructor() 
    {
    	        super();
		            this.courseContents = [];
        }
}

export class CourseContent {
    title : string;
    subTitle : string;
    url : string;
    textContent : string;

    constructor() 
    {
    	            this.title = "" ;
                this.subTitle = "" ;
                this.url = "" ;
                this.textContent = "" ;
        }
}

export class ProductCourseVm {
    createdOn : string ;
    identifier : string;
    nome : string;
    subTitle : string;
    displayOrder : number;

    constructor() 
    {
    	            this.createdOn = null;
                this.identifier = "" ;
                this.nome = "" ;
                this.subTitle = "" ;
                this.displayOrder = null ;
        }
}

export class ProductSpedibile extends BaseProduct {

    constructor() 
    {
    	        super();
		    }
}

export class ShopCategory extends BaseEntity {
    name : string;
    categoryType : string;
    order : number;
    paymentConfigDetails : PaymentConfigDetails;
    useShoppingCart : boolean;
    minProductLevelRequired : number;
    maxProductLevelRequired : number;
    nazioneFilter : string[];
    rolesFilter : string[];
    speseSpedizioneConfig : SpeseSpedizioneConfig;
    useOfferRequirements : boolean;
    isUpsellCategory : boolean;

    constructor() 
    {
    	        super();
		            this.name = "" ;
                this.categoryType = "" ;
                this.order = null ;
                this.paymentConfigDetails = new PaymentConfigDetails();
                this.useShoppingCart = false ;
                this.minProductLevelRequired = null ;
                this.maxProductLevelRequired = null ;
                this.nazioneFilter = [];
                this.rolesFilter = [];
                this.speseSpedizioneConfig = new SpeseSpedizioneConfig();
                this.useOfferRequirements = false ;
                this.isUpsellCategory = false ;
        }
}

export class PaymentConfigDetails {
    metodiPagamento : MetodoPagamento[];
    bonificoConfigDetails : BonificoConfigDetails;
    stripeConfigDetails : StripeConfigDetails;
    payPalConfigDetails : PayPalConfigDetails;
    rigaUnoRicevuta : string;
    rigaDueRicevuta : string;
    rigaTreRicevuta : string;

    constructor() 
    {
    	            this.metodiPagamento = [];
                this.bonificoConfigDetails = new BonificoConfigDetails();
                this.stripeConfigDetails = new StripeConfigDetails();
                this.payPalConfigDetails = new PayPalConfigDetails();
                this.rigaUnoRicevuta = "" ;
                this.rigaDueRicevuta = "" ;
                this.rigaTreRicevuta = "" ;
        }
}

export enum MetodoPagamento {
    Carta_di_credito = 1,
    Bonifico = 2,
    Manuale = 3,
    Gratuito = 4,
    ApplePurchase = 5,
    Stripe = 6,
    Prenotazione = 7,
    Assegnazione = 8,
    PayPal = 9,
}

export class BonificoConfigDetails {
    iban : string;
    banca : string;
    intestatoA : string;
    bicSwift : string;

    constructor() 
    {
    	            this.iban = "" ;
                this.banca = "" ;
                this.intestatoA = "" ;
                this.bicSwift = "" ;
        }
}

export class StripeConfigDetails {
    stripePublicKey : string;
    stripeSecretKey : string;

    constructor() 
    {
    	            this.stripePublicKey = "" ;
                this.stripeSecretKey = "" ;
        }
}

export class PayPalConfigDetails {
    payPalClientId : string;
    payPalSecretKey : string;

    constructor() 
    {
    	            this.payPalClientId = "" ;
                this.payPalSecretKey = "" ;
        }
}

export class SpeseSpedizioneConfig {
    soglia : number;
    preziario : { [key: string]: PreziarioEntry; };

    constructor() 
    {
    	            this.soglia = null ;
                this.preziario = {};
        }
}

export class ShopCategoryDetailsVm {
    identifier : string;
    name : string;
    order : number;
    useShoppingCart : boolean;
    metodiPagamento : MetodoPagamento[];
    stripePublicKey : string;
    payPalClientId : string;
    speseSpedizioneConfig : SpeseSpedizioneConfig;
    useOfferRequirements : boolean;
    isUpsellCategory : boolean;

    constructor() 
    {
    	            this.identifier = "" ;
                this.name = "" ;
                this.order = null ;
                this.useShoppingCart = false ;
                this.metodiPagamento = [];
                this.stripePublicKey = "" ;
                this.payPalClientId = "" ;
                this.speseSpedizioneConfig = new SpeseSpedizioneConfig();
                this.useOfferRequirements = false ;
                this.isUpsellCategory = false ;
        }
}

export class ShoppingCartVm {
    identifier : string;
    offers : OfferInCartVm[];
    totalItems : number;
    shopCategoryIdentifier : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.offers = [];
                this.totalItems = null ;
                this.shopCategoryIdentifier = "" ;
        }
}

export class SaveTemporaryCartVm {
    cart : ShoppingCart;
    applySpeseSpedizione : boolean;
    sendRicevutaCliente : boolean;
    hiddenToCustomer : boolean;
    metodoPagamento : MetodoPagamento;
    dataAcquisto : string ;

    constructor() 
    {
    	            this.cart = new ShoppingCart();
                this.applySpeseSpedizione = false ;
                this.sendRicevutaCliente = false ;
                this.hiddenToCustomer = false ;
                this.metodoPagamento = null;
                this.dataAcquisto = null;
        }
}

export class ShoppingCart extends BaseEntity {
    userIdentifier : string;
    offers : OfferQuantityPair[];
    speseSpedizione : number;

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.offers = [];
                this.speseSpedizione = null ;
        }
}

export class OfferQuantityPair {
    identifier : string;
    quantity : number;

    constructor() 
    {
    	            this.identifier = "" ;
                this.quantity = null ;
        }
}

export class Vendita extends BaseEntity {
    importo : number;
    speseSpedizione : number;
    currency : string;
    nomeProdotto : string;
    subTitleProdotto : string;
    points : number;
    nazione : string;
    transactionId : string;
    tipoPagamento : string;
    clienteIdentifier : string;
    nomeCliente : string;
    reteGestioneParent : NameIdentifier;
    reteCommercialeParent : NameIdentifier;
    acquistoClienteIdentifier : string;
    prenotazioneIdentifier : string;
    offers : OfferInCartVm[];
    confirmedOn : string ;

    constructor() 
    {
    	        super();
		            this.importo = null ;
                this.speseSpedizione = null ;
                this.currency = "" ;
                this.nomeProdotto = "" ;
                this.subTitleProdotto = "" ;
                this.points = null ;
                this.nazione = "" ;
                this.transactionId = "" ;
                this.tipoPagamento = "" ;
                this.clienteIdentifier = "" ;
                this.nomeCliente = "" ;
                this.reteGestioneParent = new NameIdentifier();
                this.reteCommercialeParent = new NameIdentifier();
                this.acquistoClienteIdentifier = "" ;
                this.prenotazioneIdentifier = "" ;
                this.offers = [];
                this.confirmedOn = null;
        }
}

export class AcquistoTableVm {
    createdOn : string ;
    identifier : string;
    clienteIdentifier : string;
    nomeCliente : string;
    telefono : Telephone;
    importo : number;
    nomeProdotto : string;
    offers : OfferInCartVm[];
    tipoPagamento : string;
    points : number;
    speseSpedizione : number;
    reteCommercialeParent : NameIdentifier;

    constructor() 
    {
    	            this.createdOn = null;
                this.identifier = "" ;
                this.clienteIdentifier = "" ;
                this.nomeCliente = "" ;
                this.telefono = new Telephone();
                this.importo = null ;
                this.nomeProdotto = "" ;
                this.offers = [];
                this.tipoPagamento = "" ;
                this.points = null ;
                this.speseSpedizione = null ;
                this.reteCommercialeParent = new NameIdentifier();
        }
}

export class PagedResultOfAcquistoTableVm {
    data : AcquistoTableVm[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class AcquistoListFilterVm extends BaseListFilterVm {
    fromDate : string ;
    toDate : string ;
    cliente : string;
    telefono : string;
    importo : number;
    spedizione : number;
    totaleCarrello : number;
    speseSpedizione : number;
    offers : string;
    prodotto : string;
    tipoPagamento : string;
    points : number;
    showPrenotazioni : boolean;
    showAssegnazioni : boolean;
    reteCommercialeParent : string;

    constructor() 
    {
    	        super();
		            this.fromDate = null;
                this.toDate = null;
                this.cliente = "" ;
                this.telefono = "" ;
                this.importo = null ;
                this.spedizione = null ;
                this.totaleCarrello = null ;
                this.speseSpedizione = null ;
                this.offers = "" ;
                this.prodotto = "" ;
                this.tipoPagamento = "" ;
                this.points = null ;
                this.showPrenotazioni = false ;
                this.showAssegnazioni = false ;
                this.reteCommercialeParent = "" ;
        }
}

export class AppConfig extends BaseEntity {
    roleModules : RoleModules[];
    primoMessaggioAperturaTicket : string;
    orariTicket : OrariAperturaTicket;
    pagamentoRequestConfig : PagamentoRequestConfig;

    constructor() 
    {
    	        super();
		            this.roleModules = [];
                this.primoMessaggioAperturaTicket = "" ;
                this.orariTicket = new OrariAperturaTicket();
                this.pagamentoRequestConfig = new PagamentoRequestConfig();
        }
}

export class RoleModules {
    role : string;
    modules : number[];

    constructor() 
    {
    	            this.role = "" ;
                this.modules = [];
        }
}

export class OrariAperturaTicket {
    text : string;
    times : OrariAperturaTicketTimes[];

    constructor() 
    {
    	            this.text = "" ;
                this.times = [];
        }
}

export class OrariAperturaTicketTimes {
    day : DayOfWeek;
    startTime : string;
    endTime : string;

    constructor() 
    {
    	            this.day = null;
                this.startTime = "" ;
                this.endTime = "" ;
        }
}

export enum DayOfWeek {
    Sunday = 0,
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
}

export class PagamentoRequestConfig {
    dayFrom : number;
    dayTo : number;
    minimumPayment : number;

    constructor() 
    {
    	            this.dayFrom = null ;
                this.dayTo = null ;
                this.minimumPayment = null ;
        }
}

export class CanRequestPaymentVm {
    pagamentoRequestConfig : PagamentoRequestConfig;
    canRequest : boolean;
    hasContratto : boolean;

    constructor() 
    {
    	            this.pagamentoRequestConfig = new PagamentoRequestConfig();
                this.canRequest = false ;
                this.hasContratto = false ;
        }
}

export class ChatRoom extends BaseEntity {
    gestitoDa : string;
    title : string;
    ticketNumber : string;
    nomeCliente : string;
    clienteIdentifier : string;
    assignedToUser : string;
    hasNewMessages : boolean;
    deviceId : string;
    description : string;
    imgUrl : string;
    subscribers : string[];
    messages : ChatMessage[];
    lastMessage : ChatMessage;

    constructor() 
    {
    	        super();
		            this.gestitoDa = "" ;
                this.title = "" ;
                this.ticketNumber = "" ;
                this.nomeCliente = "" ;
                this.clienteIdentifier = "" ;
                this.assignedToUser = "" ;
                this.hasNewMessages = false ;
                this.deviceId = "" ;
                this.description = "" ;
                this.imgUrl = "" ;
                this.subscribers = [];
                this.messages = [];
                this.lastMessage = new ChatMessage();
        }
}

export class ChatMessage {
    identifier : string;
    timestamp : number;
    sender : string;
    senderIdentifier : string;
    text : string;
    fromBackend : boolean;
    quotedMessage : QuotedMessage;

    constructor() 
    {
    	            this.identifier = "" ;
                this.timestamp = null ;
                this.sender = "" ;
                this.senderIdentifier = "" ;
                this.text = "" ;
                this.fromBackend = false ;
                this.quotedMessage = new QuotedMessage();
        }
}

export class QuotedMessage {
    sender : string;
    text : string;
    fromBackend : boolean;

    constructor() 
    {
    	            this.sender = "" ;
                this.text = "" ;
                this.fromBackend = false ;
        }
}

export class ChatRoomVm {
    disabled : boolean;
    identifier : string;
    title : string;
    ticketNumber : string;
    imgUrl : string;
    description : string;
    subscribersCount : number;
    isSubscribed : boolean;
    clienteIdentifier : string;
    assignedToUser : string;
    messagesCount : number;

    constructor() 
    {
    	            this.disabled = false ;
                this.identifier = "" ;
                this.title = "" ;
                this.ticketNumber = "" ;
                this.imgUrl = "" ;
                this.description = "" ;
                this.subscribersCount = null ;
                this.isSubscribed = false ;
                this.clienteIdentifier = "" ;
                this.assignedToUser = "" ;
                this.messagesCount = null ;
        }
}

export class RemoveChatMessagesVm {
    chatRoomIdentifier : string;
    messagesIdentifier : string[];

    constructor() 
    {
    	            this.chatRoomIdentifier = "" ;
                this.messagesIdentifier = [];
        }
}

export class ConfigurazionePrenotazioni extends BaseEntity {
    userIdentifier : string;
    address : Address;
    isVideoCall : boolean;
    orariPrenotazione : OrarioPrenotazione[];
    giorniDaEscludere : GiornoDaEscludere[];
    periodiDaEscludere : PeriodoDaEscludere[];

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.address = new Address();
                this.isVideoCall = false ;
                this.orariPrenotazione = [];
                this.giorniDaEscludere = [];
                this.periodiDaEscludere = [];
        }
}

export class OrarioPrenotazione {
    giornoSettimana : DayOfWeek;
    fasceOrarie : FasciaOraria[];

    constructor() 
    {
    	            this.giornoSettimana = null;
                this.fasceOrarie = [];
        }
}

export class GiornoDaEscludere {
    mese : number;
    giorno : number;

    constructor() 
    {
    	            this.mese = null ;
                this.giorno = null ;
        }
}

export class PeriodoDaEscludere {
    from : string ;
    to : string ;

    constructor() 
    {
    	            this.from = null;
                this.to = null;
        }
}

export class OrariPerPrenotareVm {
    date : string ;
    fasceOrarie : FasciaOraria[];
    address : Address;
    isVideoCall : boolean;

    constructor() 
    {
    	            this.date = null;
                this.fasceOrarie = [];
                this.address = new Address();
                this.isVideoCall = false ;
        }
}

export class DashboardPortafoglioVm {
    saldoAttuale : number;
    totaleInAttesa : number;
    totaleMaturato : number;
    totalePagato : number;
    richiestaPagamento : RichiestaPagamentoUser;

    constructor() 
    {
    	            this.saldoAttuale = null ;
                this.totaleInAttesa = null ;
                this.totaleMaturato = null ;
                this.totalePagato = null ;
                this.richiestaPagamento = new RichiestaPagamentoUser();
        }
}

export class RichiestaPagamentoUser extends BaseEntity {
    user : NameIdentifier;
    datiPagamento : RicevutaPaymentData;
    nazione : string;
    importo : number;
    dataRicevuta : string ;
    allegato : Attachment;
    useRitenutaAcconto : boolean;
    datiRitenutaAcconto : DatiRitenutaAcconto;
    fatturaUrl : string;
    gestitaOn : string ;

    constructor() 
    {
    	        super();
		            this.user = new NameIdentifier();
                this.datiPagamento = new RicevutaPaymentData();
                this.nazione = "" ;
                this.importo = null ;
                this.dataRicevuta = null;
                this.allegato = new Attachment();
                this.useRitenutaAcconto = false ;
                this.datiRitenutaAcconto = new DatiRitenutaAcconto();
                this.fatturaUrl = "" ;
                this.gestitaOn = null;
        }
}

export class UserPaymentData {
    bankAccountData : BankAccountData;
    paypalEmail : string;
    revolutNumber : string;
    modalitaPagamento : string;

    constructor() 
    {
    	            this.bankAccountData = new BankAccountData();
                this.paypalEmail = "" ;
                this.revolutNumber = "" ;
                this.modalitaPagamento = "" ;
        }
}

export class RicevutaPaymentData extends UserPaymentData {
    personalData : PersonalData;
    fiscalData : FiscalData;
    contactData : ContactData;

    constructor() 
    {
    	        super();
		            this.personalData = new PersonalData();
                this.fiscalData = new FiscalData();
                this.contactData = new ContactData();
        }
}

export class BankAccountData {
    intestatario : string;
    bankName : string;
    iban : string;
    swift : string;

    constructor() 
    {
    	            this.intestatario = "" ;
                this.bankName = "" ;
                this.iban = "" ;
                this.swift = "" ;
        }
}

export class DatiRitenutaAcconto {
    dataRitenuta : string;
    nomeUtente : string;
    luogoNascita : string;
    indirizzoResidenza : string;
    codiceFiscale : string;
    iban : string;
    intestatarioConto : string;
    importoLordo : string;
    importoRitenuta : string;
    importoNetto : string;

    constructor() 
    {
    	            this.dataRitenuta = "" ;
                this.nomeUtente = "" ;
                this.luogoNascita = "" ;
                this.indirizzoResidenza = "" ;
                this.codiceFiscale = "" ;
                this.iban = "" ;
                this.intestatarioConto = "" ;
                this.importoLordo = "" ;
                this.importoRitenuta = "" ;
                this.importoNetto = "" ;
        }
}

export class PerformanceChartValuesVm {
    values : DateValueOfDecimal[];
    networkValues : DateValueOfDecimal[];
    personali : number;
    network : number;

    constructor() 
    {
    	            this.values = [];
                this.networkValues = [];
                this.personali = null ;
                this.network = null ;
        }
}

export class DateValueOfDecimal {
    date : string ;
    value : number;

    constructor() 
    {
    	            this.date = null;
                this.value = null ;
        }
}

export class GuadagniChartValuesVm {
    obiettivoMensile : number;
    values : DateValueOfDecimal[];

    constructor() 
    {
    	            this.obiettivoMensile = null ;
                this.values = [];
        }
}

export class VenditoreBestVm {
    name : string;
    vendite : number;
    fatturato : number;

    constructor() 
    {
    	            this.name = "" ;
                this.vendite = null ;
                this.fatturato = null ;
        }
}

export class ObiettivoMensileVm {
    obiettivoMensile : number;
    risultato : number;

    constructor() 
    {
    	            this.obiettivoMensile = null ;
                this.risultato = null ;
        }
}

export class DashboardProfileVm {
    identifier : string;
    name : string;
    referralCode : string;
    imageUrl : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.name = "" ;
                this.referralCode = "" ;
                this.imageUrl = "" ;
        }
}

export class RicevutaUtente extends BaseEntity {
    userIdentifier : string;
    dataPagamento : string ;
    importoEuro : number;
    numeroRicevuta : string;
    note : string;
    paymentData : RicevutaPaymentData;
    isBonus : boolean;
    nazione : string;

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.dataPagamento = null;
                this.importoEuro = null ;
                this.numeroRicevuta = "" ;
                this.note = "" ;
                this.paymentData = new RicevutaPaymentData();
                this.isBonus = false ;
                this.nazione = "" ;
        }
}

export class UserCardVm {
    identifier : string;
    imageUrl : string;
    name : string;
    earned : number;
    waiting : number;

    constructor() 
    {
    	            this.identifier = "" ;
                this.imageUrl = "" ;
                this.name = "" ;
                this.earned = null ;
                this.waiting = null ;
        }
}

export class UserObiettivoCardVm {
    identifier : string;
    imageUrl : string;
    name : string;
    obiettivo : number;
    risultato : number;
    fatturato : number;

    constructor() 
    {
    	            this.identifier = "" ;
                this.imageUrl = "" ;
                this.name = "" ;
                this.obiettivo = null ;
                this.risultato = null ;
                this.fatturato = null ;
        }
}

export class SaveHelpTicketVm {
    nomeCliente : string;
    clienteIdentifier : string;
    subject : string;
    text : string;
    timeStamp : number;
    assignToUser : string;

    constructor() 
    {
    	            this.nomeCliente = "" ;
                this.clienteIdentifier = "" ;
                this.subject = "" ;
                this.text = "" ;
                this.timeStamp = null ;
                this.assignToUser = "" ;
        }
}

export class PagedResultOfHelpTicketVm {
    data : HelpTicketVm[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class HelpTicketVm {
    gestitoDa : string;
    createdOn : string ;
    identifier : string;
    disabled : boolean;
    subject : string;
    nomeCliente : string;
    clienteIdentifier : string;
    ticketNumber : string;
    deviceId : string;
    hasNewMessages : boolean;
    fromBackend : boolean;
    assignedToUser : string;

    constructor() 
    {
    	            this.gestitoDa = "" ;
                this.createdOn = null;
                this.identifier = "" ;
                this.disabled = false ;
                this.subject = "" ;
                this.nomeCliente = "" ;
                this.clienteIdentifier = "" ;
                this.ticketNumber = "" ;
                this.deviceId = "" ;
                this.hasNewMessages = false ;
                this.fromBackend = false ;
                this.assignedToUser = "" ;
        }
}

export class TicketListFilterVm {
    pageNumber : number;
    perPage : number;
    sortBy : SortByParameter;
    createdOn : string ;
    stillOpenOnly : boolean;
    nomeCliente : string;
    subject : string;
    ticketNumber : string;
    gestitoDa : string;

    constructor() 
    {
    	            this.pageNumber = null ;
                this.perPage = null ;
                this.sortBy = new SortByParameter();
                this.createdOn = null;
                this.stillOpenOnly = false ;
                this.nomeCliente = "" ;
                this.subject = "" ;
                this.ticketNumber = "" ;
                this.gestitoDa = "" ;
        }
}

export class GetOrariAperturaTicketVmV2 {
    text : string;
    canOpen : boolean;

    constructor() 
    {
    	            this.text = "" ;
                this.canOpen = false ;
        }
}

export class HtmlTextConfig extends BaseEntity {
    primoMessaggioAperturaTicket : string;
    orariTicket : OrariAperturaTicket;

    constructor() 
    {
    	        super();
		            this.primoMessaggioAperturaTicket = "" ;
                this.orariTicket = new OrariAperturaTicket();
        }
}

export class NetworkUserVM {
    createdOn : string ;
    level : number;
    username : string;
    nome : string;
    imageUrl : string;
    referralCode : string;
    role : string;
    qualifica : QualificaProvvigioni;
    disattivaCalcolo : boolean;
    puntiReteMaturati : number;
    identifier : string;
    parentIdentifier : string;
    totaleClienti : number;
    nonFumatore : boolean;

    constructor() 
    {
    	            this.createdOn = null;
                this.level = null ;
                this.username = "" ;
                this.nome = "" ;
                this.imageUrl = "" ;
                this.referralCode = "" ;
                this.role = "" ;
                this.qualifica = new QualificaProvvigioni();
                this.disattivaCalcolo = false ;
                this.puntiReteMaturati = null ;
                this.identifier = "" ;
                this.parentIdentifier = "" ;
                this.totaleClienti = null ;
                this.nonFumatore = false ;
        }
}

export class PayPalCaptureOrderResponse {
    id : string;
    status : string;
    payment_source : PaymentSource;
    purchase_units : PurchaseUnit[];
    payer : Payer;
    links : Link[];

    constructor() 
    {
    	            this.id = "" ;
                this.status = "" ;
                this.payment_source = new PaymentSource();
                this.purchase_units = [];
                this.payer = new Payer();
                this.links = [];
        }
}

export class PaymentSource {
    paypal : Paypal;

    constructor() 
    {
    	            this.paypal = new Paypal();
        }
}

export class Paypal {
    email_address : string;
    account_id : string;
    name : Name;
    address : Address2;

    constructor() 
    {
    	            this.email_address = "" ;
                this.account_id = "" ;
                this.name = new Name();
                this.address = new Address2();
        }
}

export class Name {
    given_name : string;
    surname : string;
    full_name : string;

    constructor() 
    {
    	            this.given_name = "" ;
                this.surname = "" ;
                this.full_name = "" ;
        }
}

export class Address2 {
    country_code : string;
    address_line_1 : string;
    admin_area_2 : string;
    admin_area_1 : string;
    postal_code : string;

    constructor() 
    {
    	            this.country_code = "" ;
                this.address_line_1 = "" ;
                this.admin_area_2 = "" ;
                this.admin_area_1 = "" ;
                this.postal_code = "" ;
        }
}

export class PurchaseUnit {
    reference_id : string;
    shipping : Shipping;
    payments : Payments;

    constructor() 
    {
    	            this.reference_id = "" ;
                this.shipping = new Shipping();
                this.payments = new Payments();
        }
}

export class Shipping {
    name : Name;
    address : Address2;

    constructor() 
    {
    	            this.name = new Name();
                this.address = new Address2();
        }
}

export class Payments {
    captures : Capture[];

    constructor() 
    {
    	            this.captures = [];
        }
}

export class Capture {
    id : string;
    status : string;
    amount : Amount;
    final_capture : boolean;
    seller_protection : SellerProtection;
    seller_receivable_breakdown : SellerReceivableBreakdown;
    links : Link[];
    create_time : string ;
    update_time : string ;

    constructor() 
    {
    	            this.id = "" ;
                this.status = "" ;
                this.amount = new Amount();
                this.final_capture = false ;
                this.seller_protection = new SellerProtection();
                this.seller_receivable_breakdown = new SellerReceivableBreakdown();
                this.links = [];
                this.create_time = null;
                this.update_time = null;
        }
}

export class Amount {
    currency_code : string;
    value : string;

    constructor() 
    {
    	            this.currency_code = "" ;
                this.value = "" ;
        }
}

export class SellerProtection {
    status : string;
    dispute_categories : string[];

    constructor() 
    {
    	            this.status = "" ;
                this.dispute_categories = [];
        }
}

export class SellerReceivableBreakdown {
    gross_amount : GrossAmount;
    paypal_fee : PaypalFee;
    net_amount : NetAmount;

    constructor() 
    {
    	            this.gross_amount = new GrossAmount();
                this.paypal_fee = new PaypalFee();
                this.net_amount = new NetAmount();
        }
}

export class GrossAmount {
    currency_code : string;
    value : string;

    constructor() 
    {
    	            this.currency_code = "" ;
                this.value = "" ;
        }
}

export class PaypalFee {
    currency_code : string;
    value : string;

    constructor() 
    {
    	            this.currency_code = "" ;
                this.value = "" ;
        }
}

export class NetAmount {
    currency_code : string;
    value : string;

    constructor() 
    {
    	            this.currency_code = "" ;
                this.value = "" ;
        }
}

export class Link {
    href : string;
    rel : string;
    method : string;

    constructor() 
    {
    	            this.href = "" ;
                this.rel = "" ;
                this.method = "" ;
        }
}

export class Payer {
    name : Name;
    email_address : string;
    payer_id : string;
    address : Address2;

    constructor() 
    {
    	            this.name = new Name();
                this.email_address = "" ;
                this.payer_id = "" ;
                this.address = new Address2();
        }
}

export class Prenotazione extends BaseEntity {
    user : NameIdentifier;
    cliente : NameIdentifier;
    date : string ;
    orario : FasciaOraria;
    note : string;
    statoHistory : DateValueOfString[];
    ticketPrenotazioneIdentifier : string;
    statoMacchinaAntismoking : StatoMacchinaAntismoking;

    constructor() 
    {
    	        super();
		            this.user = new NameIdentifier();
                this.cliente = new NameIdentifier();
                this.date = null;
                this.orario = new FasciaOraria();
                this.note = "" ;
                this.statoHistory = [];
                this.ticketPrenotazioneIdentifier = "" ;
                this.statoMacchinaAntismoking = new StatoMacchinaAntismoking();
        }
}

export class StatoMacchinaAntismoking {
    puntoTrattamento : string;
    secondiTrascorsi : string;
    durataImpulso : string;
    durataTrattamentoPunto : string;
    statoMacchina : string;

    constructor() 
    {
    	            this.puntoTrattamento = "" ;
                this.secondiTrascorsi = "" ;
                this.durataImpulso = "" ;
                this.durataTrattamentoPunto = "" ;
                this.statoMacchina = "" ;
        }
}

export class PrenotazioneForListVm {
    identifier : string;
    cliente : NameIdentifier;
    user : NameIdentifier;
    data : string ;
    fasciaOraria : FasciaOraria;
    stato : DateValueOfString;
    note : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.cliente = new NameIdentifier();
                this.user = new NameIdentifier();
                this.data = null;
                this.fasciaOraria = new FasciaOraria();
                this.stato = new DateValueOfString();
                this.note = "" ;
        }
}

export class PagedResultOfPrenotazioneForListVm {
    data : PrenotazioneForListVm[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class GetPrenotazioniFilterVm extends BaseListFilterVm {
    cliente : string;
    user : string;
    fromDate : string ;
    toDate : string ;
    fasciaOraria : string;
    stato : string;
    note : string;

    constructor() 
    {
    	        super();
		            this.cliente = "" ;
                this.user = "" ;
                this.fromDate = null;
                this.toDate = null;
                this.fasciaOraria = "" ;
                this.stato = "" ;
                this.note = "" ;
        }
}

export class SaveStatoMacchinaAntismokingVm {
    prenotazioneIdentifier : string;
    statoMacchina : StatoMacchinaAntismoking;

    constructor() 
    {
    	            this.prenotazioneIdentifier = "" ;
                this.statoMacchina = new StatoMacchinaAntismoking();
        }
}

export class MakePrenotazioneVm {
    ticketPrenotazioneIdentifier : string;
    cliente : NameIdentifier;
    user : NameIdentifier;
    prenotazioneIdentifier : string;
    date : string ;
    fasciaOraria : FasciaOraria;
    note : string;

    constructor() 
    {
    	            this.ticketPrenotazioneIdentifier = "" ;
                this.cliente = new NameIdentifier();
                this.user = new NameIdentifier();
                this.prenotazioneIdentifier = "" ;
                this.date = null;
                this.fasciaOraria = new FasciaOraria();
                this.note = "" ;
        }
}

export class PagedResultOfProvvigioniListVm {
    data : ProvvigioniListVm[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class ProvvigioniListVm {
    identifier : string;
    createdOn : string ;
    prodotto : string;
    nazione : string;
    cliente : string;
    importoEuro : string;
    figlio : string;
    utente : string;
    qualificaFiglio : string;
    qualificaUtente : string;
    points : number;
    guadagnoEuro : number;
    offers : OfferInCartVm[];

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.prodotto = "" ;
                this.nazione = "" ;
                this.cliente = "" ;
                this.importoEuro = "" ;
                this.figlio = "" ;
                this.utente = "" ;
                this.qualificaFiglio = "" ;
                this.qualificaUtente = "" ;
                this.points = null ;
                this.guadagnoEuro = null ;
                this.offers = [];
        }
}

export class ProvvigioniListFilterVm {
    userIdentifier : string;
    pageNumber : number;
    perPage : number;
    createdOn : string ;
    fromDate : string ;
    toDate : string ;
    cliente : string;
    prodotto : string;
    importoEuro : number;
    figlio : string;
    qualificaFiglio : string;
    utente : string;
    qualificaUtente : string;
    points : number;
    guadagnoEuro : number;

    constructor() 
    {
    	            this.userIdentifier = "" ;
                this.pageNumber = null ;
                this.perPage = null ;
                this.createdOn = null;
                this.fromDate = null;
                this.toDate = null;
                this.cliente = "" ;
                this.prodotto = "" ;
                this.importoEuro = null ;
                this.figlio = "" ;
                this.qualificaFiglio = "" ;
                this.utente = "" ;
                this.qualificaUtente = "" ;
                this.points = null ;
                this.guadagnoEuro = null ;
        }
}

export class ProvvigioniFilterVm extends BaseListFilterVm {
    userIdentifier : string;
    createdOn : string ;
    fromDate : string ;
    toDate : string ;
    cliente : string;
    prodotto : string;
    offers : string;
    importoEuro : number;
    nazione : string;
    figlio : string;
    qualificaFiglio : string;
    utente : string;
    qualificaUtente : string;
    points : number;
    guadagnoEuro : number;

    constructor() 
    {
    	        super();
		            this.userIdentifier = "" ;
                this.createdOn = null;
                this.fromDate = null;
                this.toDate = null;
                this.cliente = "" ;
                this.prodotto = "" ;
                this.offers = "" ;
                this.importoEuro = null ;
                this.nazione = "" ;
                this.figlio = "" ;
                this.qualificaFiglio = "" ;
                this.utente = "" ;
                this.qualificaUtente = "" ;
                this.points = null ;
                this.guadagnoEuro = null ;
        }
}

export class SimulaProvvigioniRequestVm {
    qualificaAttuale : QualificaProvvigioni;
    puntiTotali : number;
    puntiMensili : number;
    puntiTrimestrali : number;
    puntiSemestrali : number;
    puntiAnnuali : number;
    trimestrale : boolean;
    semestrale : boolean;
    annuale : boolean;
    mese : number;
    anno : number;

    constructor() 
    {
    	            this.qualificaAttuale = new QualificaProvvigioni();
                this.puntiTotali = null ;
                this.puntiMensili = null ;
                this.puntiTrimestrali = null ;
                this.puntiSemestrali = null ;
                this.puntiAnnuali = null ;
                this.trimestrale = false ;
                this.semestrale = false ;
                this.annuale = false ;
                this.mese = null ;
                this.anno = null ;
        }
}

export class QualificaProvvigioniConfig extends BaseEntity {
    codiceQualifica : string;
    puntiTotaliNecessari : number;
    euroPerPunto : number;
    manuale : boolean;
    isQualificaBase : boolean;
    isQualificaInizioCollaboratori : boolean;
    modalitaCalcolo : string;

    constructor() 
    {
    	        super();
		            this.codiceQualifica = "" ;
                this.puntiTotaliNecessari = null ;
                this.euroPerPunto = null ;
                this.manuale = false ;
                this.isQualificaBase = false ;
                this.isQualificaInizioCollaboratori = false ;
                this.modalitaCalcolo = "" ;
        }
}

export class RicevutaCliente extends BaseEntity {
    acquistoClienteIdentifier : string;
    acquistoIdentifier : string;
    numeroRicevuta : number;
    data : string;
    nome : string;
    cognome : string;
    hasCf : boolean;
    cf : string;
    indirizzo : string;
    metodoPagamento : string;
    prodotto : string;
    subTitleProdotto : string;
    quantita : string;
    prezzo : string;
    currency : string;
    hasVat : boolean;
    vat : string;
    totale : string;

    constructor() 
    {
    	        super();
		            this.acquistoClienteIdentifier = "" ;
                this.acquistoIdentifier = "" ;
                this.numeroRicevuta = null ;
                this.data = "" ;
                this.nome = "" ;
                this.cognome = "" ;
                this.hasCf = false ;
                this.cf = "" ;
                this.indirizzo = "" ;
                this.metodoPagamento = "" ;
                this.prodotto = "" ;
                this.subTitleProdotto = "" ;
                this.quantita = "" ;
                this.prezzo = "" ;
                this.currency = "" ;
                this.hasVat = false ;
                this.vat = "" ;
                this.totale = "" ;
        }
}

export class RicevutaUtenteInsertVm {
    numeroRicevuta : string;
    data : string ;
    importo : number;
    note : string;
    userIdentifier : string;
    nazione : string;

    constructor() 
    {
    	            this.numeroRicevuta = "" ;
                this.data = null;
                this.importo = null ;
                this.note = "" ;
                this.userIdentifier = "" ;
                this.nazione = "" ;
        }
}

export class RisposteQuestionario extends BaseEntity {
    deviceId : string;
    deviceType : string;
    questionarioIdentifier : string;
    punteggio : number;
    answerValues : AnswerValue[];

    constructor() 
    {
    	        super();
		            this.deviceId = "" ;
                this.deviceType = "" ;
                this.questionarioIdentifier = "" ;
                this.punteggio = null ;
                this.answerValues = [];
        }
}

export class AnswerValue {
    domandaText : string;
    answerText : string;
    value : number;

    constructor() 
    {
    	            this.domandaText = "" ;
                this.answerText = "" ;
                this.value = null ;
        }
}

export class StripeCardDetailVm {
    cardId : string;
    brand : string;
    country : string;
    currency : string;
    expMonth : number;
    expYear : number;
    dynamicLast4 : string;
    last4 : string;
    holder : string;

    constructor() 
    {
    	            this.cardId = "" ;
                this.brand = "" ;
                this.country = "" ;
                this.currency = "" ;
                this.expMonth = null ;
                this.expYear = null ;
                this.dynamicLast4 = "" ;
                this.last4 = "" ;
                this.holder = "" ;
        }
}

export class PagedResultOfTicketPrenotazione {
    data : TicketPrenotazione[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class TicketPrenotazione extends BaseEntity {
    product : NameIdentifier;
    cliente : NameIdentifier;
    usedOn : string ;
    prenotazioneIdentifier : string;
    centroFumo : NameIdentifier;
    offertaIdentifier : string;
    ruoloPrenotazione : string;

    constructor() 
    {
    	        super();
		            this.product = new NameIdentifier();
                this.cliente = new NameIdentifier();
                this.usedOn = null;
                this.prenotazioneIdentifier = "" ;
                this.centroFumo = new NameIdentifier();
                this.offertaIdentifier = "" ;
                this.ruoloPrenotazione = "" ;
        }
}

export class TicketPrenotazioneListFilterVm {
    pageNumber : number;
    perPage : number;
    createdOn : string ;
    fromDate : string ;
    toDate : string ;
    cliente : string;
    product : string;
    usedFrom : string ;
    usedTo : string ;

    constructor() 
    {
    	            this.pageNumber = null ;
                this.perPage = null ;
                this.createdOn = null;
                this.fromDate = null;
                this.toDate = null;
                this.cliente = "" ;
                this.product = "" ;
                this.usedFrom = null;
                this.usedTo = null;
        }
}

export class TicketPrenotazioneWithRoleVm {
    identifier : string;
    ruoloPrenotazione : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.ruoloPrenotazione = "" ;
        }
}

export class AssignToVm {
    userIdentifier : string;
    assignTo : NameIdentifier;

    constructor() 
    {
    	            this.userIdentifier = "" ;
                this.assignTo = new NameIdentifier();
        }
}

export class UpdateBaseUserVm {
    identifier : string;
    personalData : PersonalData;
    contactData : ContactData;
    fiscalData : FiscalData;
    referralCode : string;
    reteGestioneParent : NameIdentifier;
    reteCommercialeParent : NameIdentifier;
    role : string;
    appModules : number[];

    constructor() 
    {
    	            this.identifier = "" ;
                this.personalData = new PersonalData();
                this.contactData = new ContactData();
                this.fiscalData = new FiscalData();
                this.referralCode = "" ;
                this.reteGestioneParent = new NameIdentifier();
                this.reteCommercialeParent = new NameIdentifier();
                this.role = "" ;
                this.appModules = [];
        }
}

export class UpdateLeadVm extends UpdateBaseUserVm {
    authData : AuthData;
    calcoliFumo : CalcoliFumo;
    socialNetworksData : SocialNetworksData;
    note : Comment[];
    comments : Comment[];
    statoCommerciale : string;
    status : string;
    subStatus : string;
    cronologiaStati : Comment[];
    scadenze : Comment[];
    list : string;
    source : string;
    lavorato : boolean;
    provvigioniCassaforte : boolean;
    stripeCustomerIds : AutoDictionaryOfStringAndString;
    productLevel : number;
    pianoProvvigioni : PianoProvvigioni;
    storicoPianoProvvigioni : DateValueOfPianoProvvigioni[];

    constructor() 
    {
    	        super();
		            this.authData = new AuthData();
                this.calcoliFumo = new CalcoliFumo();
                this.socialNetworksData = new SocialNetworksData();
                this.note = [];
                this.comments = [];
                this.statoCommerciale = "" ;
                this.status = "" ;
                this.subStatus = "" ;
                this.cronologiaStati = [];
                this.scadenze = [];
                this.list = "" ;
                this.source = "" ;
                this.lavorato = false ;
                this.provvigioniCassaforte = false ;
                this.stripeCustomerIds = new AutoDictionaryOfStringAndString();
                this.productLevel = null ;
                this.pianoProvvigioni = new PianoProvvigioni();
                this.storicoPianoProvvigioni = [];
        }
}

export class UpdateClienteVm extends UpdateLeadVm {

    constructor() 
    {
    	        super();
		    }
}

export class AttivaOffertaMultipleFromBackendRequestVm {
    clienteIdentifierList : string[];
    offertaIdentifier : string;

    constructor() 
    {
    	            this.clienteIdentifierList = [];
                this.offertaIdentifier = "" ;
        }
}

export class PagedResultOfClienteVm {
    data : ClienteVm[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class ClienteVm {
    referralCode : string;
    role : string;
    cognome : string;
    nome : string;
    createdOn : string ;
    email : string;
    identifier : string;
    nutrizionista : NameIdentifier;
    nazione : string;
    cellulare : string;
    nonFumatore : boolean;
    statoCommerciale : string;
    reteGestioneParent : NameIdentifier;
    reteCommercialeParent : NameIdentifier;

    constructor() 
    {
    	            this.referralCode = "" ;
                this.role = "" ;
                this.cognome = "" ;
                this.nome = "" ;
                this.createdOn = null;
                this.email = "" ;
                this.identifier = "" ;
                this.nutrizionista = new NameIdentifier();
                this.nazione = "" ;
                this.cellulare = "" ;
                this.nonFumatore = false ;
                this.statoCommerciale = "" ;
                this.reteGestioneParent = new NameIdentifier();
                this.reteCommercialeParent = new NameIdentifier();
        }
}

export class ClientiListFilterVm extends BaseListFilterVm {
    createdOn : string ;
    nutrizionistaIdentifier : string;
    referralCode : string;
    reteCommercialeParent : string;
    reteGestioneParent : string;
    soloNonFumatori : boolean;
    role : string;
    nome : string;
    cognome : string;
    email : string;
    nazione : string;
    nutrizionista : string;
    cellulare : string;
    statoCommerciale : string;

    constructor() 
    {
    	        super();
		            this.createdOn = null;
                this.nutrizionistaIdentifier = "" ;
                this.referralCode = "" ;
                this.reteCommercialeParent = "" ;
                this.reteGestioneParent = "" ;
                this.soloNonFumatori = false ;
                this.role = "" ;
                this.nome = "" ;
                this.cognome = "" ;
                this.email = "" ;
                this.nazione = "" ;
                this.nutrizionista = "" ;
                this.cellulare = "" ;
                this.statoCommerciale = "" ;
        }
}

export class UpdateCollaboratoreVm extends UpdateClienteVm {
    obiettivoMensile : number;
    paymentData : UserPaymentData;
    commercialeDiRiferimento : NameIdentifier;

    constructor() 
    {
    	        super();
		            this.obiettivoMensile = null ;
                this.paymentData = new UserPaymentData();
                this.commercialeDiRiferimento = new NameIdentifier();
        }
}

export class LatLongIdentifierVm {
    latLong : LatLong;
    identifier : string;

    constructor() 
    {
    	            this.latLong = new LatLong();
                this.identifier = "" ;
        }
}

export class CentroFumoDetailsVm {
    identifier : string;
    name : string;
    contactData : ContactData;

    constructor() 
    {
    	            this.identifier = "" ;
                this.name = "" ;
                this.contactData = new ContactData();
        }
}

export class UpdateUserVm {
    identifier : string;
    email : string;
    username : string;
    nome : string;
    cognome : string;
    password : string;
    appModules : number[];
    referralCode : string;
    parentIdentifier : string;
    qualificaProvvigioni : string;
    lockQualifica : boolean;
    profileConfirmed : boolean;
    isAdmin : boolean;
    team : NameIdentifier;
    role : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.email = "" ;
                this.username = "" ;
                this.nome = "" ;
                this.cognome = "" ;
                this.password = "" ;
                this.appModules = [];
                this.referralCode = "" ;
                this.parentIdentifier = "" ;
                this.qualificaProvvigioni = "" ;
                this.lockQualifica = false ;
                this.profileConfirmed = false ;
                this.isAdmin = false ;
                this.team = new NameIdentifier();
                this.role = "" ;
        }
}

export class Collaboratore extends Cliente {
    obiettivoMensile : number;
    storicoObiettivoMensile : DateValueOfDecimal[];
    paymentData : UserPaymentData;
    commercialeDiRiferimento : NameIdentifier;

    constructor() 
    {
    	        super();
		            this.obiettivoMensile = null ;
                this.storicoObiettivoMensile = [];
                this.paymentData = new UserPaymentData();
                this.commercialeDiRiferimento = new NameIdentifier();
        }
}

export class CreateUserVm {
    email : string;
    password : string;
    username : string;
    appModules : number[];
    referralCode : string;

    constructor() 
    {
    	            this.email = "" ;
                this.password = "" ;
                this.username = "" ;
                this.appModules = [];
                this.referralCode = "" ;
        }
}

export class CollaboratoreListVm {
    identifier : string;
    createdOn : string ;
    email : string;
    name : string;
    username : string;
    referralCode : string;
    reteGestioneParent : NameIdentifier;
    reteCommercialeParent : NameIdentifier;
    loginEnabled : boolean;
    role : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.email = "" ;
                this.name = "" ;
                this.username = "" ;
                this.referralCode = "" ;
                this.reteGestioneParent = new NameIdentifier();
                this.reteCommercialeParent = new NameIdentifier();
                this.loginEnabled = false ;
                this.role = "" ;
        }
}

export class PromoRegisterVM {
    email : string;
    password : string;
    promoCode : string;

    constructor() 
    {
    	            this.email = "" ;
                this.password = "" ;
                this.promoCode = "" ;
        }
}

export class UserWithReferralVM {
    identifier : string;
    nome : string;
    cognome : string;
    referralCode : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.nome = "" ;
                this.cognome = "" ;
                this.referralCode = "" ;
        }
}

export class LeadInAccettazioneVm {
    identifier : string;
    createdOn : string ;
    assignedOn : string ;
    acceptedOn : string ;
    assignedTo : NameIdentifier;
    contactName : string;
    name : string;
    surname : string;
    reteCommercialeParent : NameIdentifier;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.assignedOn = null;
                this.acceptedOn = null;
                this.assignedTo = new NameIdentifier();
                this.contactName = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.reteCommercialeParent = new NameIdentifier();
        }
}

export class UpdateCalcoliFumoVm {
    identifier : string;
    calcoliFumo : CalcoliFumo;

    constructor() 
    {
    	            this.identifier = "" ;
                this.calcoliFumo = new CalcoliFumo();
        }
}

export class UpdateAddressVm {
    identifier : string;
    address : Address;

    constructor() 
    {
    	            this.identifier = "" ;
                this.address = new Address();
        }
}

export class NewLeadVm {
    personalData : PersonalData;
    authData : AuthData;
    contactData : ContactData;
    list : string;
    productLevel : number;

    constructor() 
    {
    	            this.personalData = new PersonalData();
                this.authData = new AuthData();
                this.contactData = new ContactData();
                this.list = "" ;
                this.productLevel = null ;
        }
}

export class UpdateLuogoDataNascitaVm {
    identifier : string;
    luogo : string;
    dataNascita : string ;

    constructor() 
    {
    	            this.identifier = "" ;
                this.luogo = "" ;
                this.dataNascita = null;
        }
}

export class ResetPasswordVm {
    email : string;
    password : string;
    token : string;

    constructor() 
    {
    	            this.email = "" ;
                this.password = "" ;
                this.token = "" ;
        }
}

export class StoricoAssegnazioneVm {
    lead : NameIdentifier;
    storicoAssegnazione : DateValueOfStoricoAssegnazione;

    constructor() 
    {
    	            this.lead = new NameIdentifier();
                this.storicoAssegnazione = new DateValueOfStoricoAssegnazione();
        }
}

export class GetScadenzeLeadVm {
    scadenze : LeadScadenzaVm[];

    constructor() 
    {
    	            this.scadenze = [];
        }
}

export class LeadScadenzaVm {
    identifier : string;
    contactName : string;
    name : string;
    scadenza : Comment;
    status : string;
    subStatus : string;

    constructor() 
    {
    	            this.identifier = "" ;
                this.contactName = "" ;
                this.name = "" ;
                this.scadenza = new Comment();
                this.status = "" ;
                this.subStatus = "" ;
        }
}

export class PagedResultOfLeadTableVm {
    data : LeadTableVm[];
    count : number;
    pageNumber : number;
    perPage : number;

    constructor() 
    {
    	            this.data = [];
                this.count = null ;
                this.pageNumber = null ;
                this.perPage = null ;
        }
}

export class LeadTableVm {
    identifier : string;
    createdOn : string ;
    contactName : string;
    name : string;
    surname : string;
    email : string;
    telephone : string;
    status : string;
    subStatus : string;
    userGestione : NameIdentifier;
    userCommerciale : NameIdentifier;
    scadenze : Comment[];
    role : string;
    centroTrattamento : NameIdentifier;
    fumatore : boolean;

    constructor() 
    {
    	            this.identifier = "" ;
                this.createdOn = null;
                this.contactName = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.email = "" ;
                this.telephone = "" ;
                this.status = "" ;
                this.subStatus = "" ;
                this.userGestione = new NameIdentifier();
                this.userCommerciale = new NameIdentifier();
                this.scadenze = [];
                this.role = "" ;
                this.centroTrattamento = new NameIdentifier();
                this.fumatore = false ;
        }
}

export class LeadListFilterVm {
    pageNumber : number;
    perPage : number;
    sortBy : SortByParameter;
    userIdentifier : string;
    selectedList : string;
    showCustomers : boolean;
    showCollaboratori : boolean;
    showTelephoneOnly : boolean;
    subStatusFilter : string;
    showInRitardoOnly : boolean;
    soloNonFumatori : boolean;
    createdOn : string ;
    contactName : string;
    name : string;
    surname : string;
    telephone : string;
    email : string;
    status : string;
    userGestione : string;
    userCommerciale : string;

    constructor() 
    {
    	            this.pageNumber = null ;
                this.perPage = null ;
                this.sortBy = new SortByParameter();
                this.userIdentifier = "" ;
                this.selectedList = "" ;
                this.showCustomers = false ;
                this.showCollaboratori = false ;
                this.showTelephoneOnly = false ;
                this.subStatusFilter = "" ;
                this.showInRitardoOnly = false ;
                this.soloNonFumatori = false ;
                this.createdOn = null;
                this.contactName = "" ;
                this.name = "" ;
                this.surname = "" ;
                this.telephone = "" ;
                this.email = "" ;
                this.status = "" ;
                this.userGestione = "" ;
                this.userCommerciale = "" ;
        }
}

export class SaveLeadActionVm {
    leadIdentifier : string;
    type : string;
    comment : string;
    status : string;
    scadenza : string ;
    durata : number;

    constructor() 
    {
    	            this.leadIdentifier = "" ;
                this.type = "" ;
                this.comment = "" ;
                this.status = "" ;
                this.scadenza = null;
                this.durata = null ;
        }
}

export class MultipleLeadsActionVm {
    leadList : string[];
    user : string;
    list : string;
    treeType : string;

    constructor() 
    {
    	            this.leadList = [];
                this.user = "" ;
                this.list = "" ;
                this.treeType = "" ;
        }
}

export class CheckNumberVm {
    identifier : string;
    telephone : Telephone;

    constructor() 
    {
    	            this.identifier = "" ;
                this.telephone = new Telephone();
        }
}

export class UpgradeLeadVm {
    leadIdentifier : string;
    username : string;
    password : string;

    constructor() 
    {
    	            this.leadIdentifier = "" ;
                this.username = "" ;
                this.password = "" ;
        }
}

export class LeadColonneVm {
    inArrivo : LeadTableVm[];
    appuntamento : LeadTableVm[];
    trattamento : LeadTableVm[];
    mese1 : LeadTableVm[];
    mese2 : LeadTableVm[];
    mese3 : LeadTableVm[];
    mese4 : LeadTableVm[];
    mese5 : LeadTableVm[];
    mese6 : LeadTableVm[];
    ricaduto : LeadTableVm[];
    conclusionePositiva : LeadTableVm[];

    constructor() 
    {
    	            this.inArrivo = [];
                this.appuntamento = [];
                this.trattamento = [];
                this.mese1 = [];
                this.mese2 = [];
                this.mese3 = [];
                this.mese4 = [];
                this.mese5 = [];
                this.mese6 = [];
                this.ricaduto = [];
                this.conclusionePositiva = [];
        }
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}